import React from "react";

// Pages
import RoundRegContext from "./RoundRegContext";
import RoundRegContainer from './container/RoundRegContainer';

const RoundReg = () => {
	return (
		<RoundRegContext>
			<RoundRegContainer/>
		</RoundRegContext>
	);
};

export default RoundReg;
